// extracted by mini-css-extract-plugin
module.exports = {"verticalProductCard":"verticalPage_verticalProductCard__VuJRc","productCardSkeleton":"verticalPage_productCardSkeleton__CEA0F"};